<template>
  <div class="container">
    <div>
      <div>本週成功天數</div>
      <div class="circle">{{ weekSuccessDays }}</div>
    </div>
    <div>
      <div>本月成功天數</div>
      <div class="circle">{{ monthSuccessDays }}</div>
    </div>
  </div>
</template>

<script>
import { sendMessages } from "../../utils/liffHelper";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYear);

export default {
  props: {
    userData: Object
  },
  data() {
    return {
      thisWeek: null,
      thisMonth: null
    };
  },
  name: "Statistics",
  computed: {
    weekSuccessDays() {
      const val = Object.keys(this.userData).filter(key => {
        return this.userData[key] && dayjs(key).week() === this.thisWeek;
      }).length;
      if (val == 7) {
        sendMessages("真佩服我自己");
      }
      return val;
    },
    monthSuccessDays() {
      return Object.keys(this.userData).filter(key => {
        return this.userData[key] && dayjs(key).month() === this.thisMonth;
      }).length;
    }
  },
  mounted() {
    this.thisWeek = dayjs().week();
    this.thisMonth = dayjs().month();
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  margin-top: 100px;
  justify-content: space-evenly;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.circle {
  margin-top: 10px;
  width: 50px;
  height: 50px;
  border: 1px solid #e8e8e8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
